module.exports = __webpack_public_path__ + "img/quick-sigorta.46ad87a2.jpg";